<template>
	<b-notification type="is-primary" :closable="false" v-if="selectedMemberType">
		<p class="is-size-4">
			<b>You have selected:</b>
		</p>
		<p>
			Member Level - <strong>{{ displayTypeDetails.type }}</strong>
		</p>
		<p v-if="!shouldHideNhsFields">
			NHS Medical - <strong>{{ displayTypeDetails.nhsMedical }}</strong>
		</p>
		<p v-if="!shouldHideNhsFields">
			Non-Clinical Scientist -
			<strong>{{ displayTypeDetails.nonClinical }}</strong>
		</p>
		<p v-if="!shouldHideNhsFields">
			A4C - <strong>{{ displayTypeDetails.nhs }}</strong>
		</p>
		<p>
			Price - <strong>{{ displayTypeDetails.price }}</strong> <span v-if="!shouldHideNhsFields">per year</span>
		</p>
	</b-notification>
</template>

<script>
export default {
	name: 'SelectedMemberNotification',

	props: {
		selectedMemberType: {
			type: String,
			required: false,
		},
		affiliatedOrganization: {
			type: [String, Number],
			required: false,
			default: null,
		},
	},

	data() {
		return {
			typeDetails: {},
		};
	},

	computed: {
		shouldHideNhsFields() {
			return this.selectedMemberType === 'BTPT' || this.selectedMemberType === 'Herrick' || this.selectedMemberType === 'HERR';
		},
		isAffiliateMember() {
			// Check if this is an affiliate membership (Reduced/Standard/Consultant with affiliated org)
			return this.selectedMemberType && 
				   this.affiliatedOrganization && 
				   ['Reduced', 'Standard', 'Consultant'].includes(this.selectedMemberType);
		},
		displayTypeDetails() {
			// Copy the Return Objects from the ApplicationForm component data section (or vice-versa)
			const baseDetails = (() => {
				switch (this.selectedMemberType) {
					case 'Reduced':
						return {
							type: this.isAffiliateMember ? 'Reduced Affiliate' : 'Reduced',
							nhsMedical: 'Student',
							nonClinical: 'Scientist',
							nhs: 'Band 7 and Below',
							price: this.isAffiliateMember ? '£20.00' : '£40.00',
						};
					case 'Standard':
						return {
							type: this.isAffiliateMember ? 'Standard Affiliate' : 'Standard',
							nhsMedical: 'FY, Core Trainees, STs and equivalent',
							nonClinical: 'Lecturer',
							nhs: 'Band 8a, 8b or 8c',
							price: this.isAffiliateMember ? '£52.50' : '£105.00',
						};
					case 'Consultant':
						return {
							type: this.isAffiliateMember ? 'Consultant Affiliate' : 'Consultant',
							nhsMedical: 'Consultant',
							nonClinical: 'Senior Lecturer, Reader, Professor',
							nhs: 'Band 8d or above',
							price: this.isAffiliateMember ? '£75.00' : '£150.00',
						};
					case 'BTPT':
						return {
							type: 'BTPT Only',
							nhsMedical: '—',
							nonClinical: '—',
							nhs: '—',
							price: '£15.00',
						};
					case 'HERR':
						return {
							type: 'Herrick Only',
							nhsMedical: '—',
							nonClinical: '—',
							nhs: '—',
							price: '£15.00',
						};
					default:
						return null;
				}
			})();
			
			return baseDetails;
		},
	},
};
</script>

<style></style>
